var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"session-info-title"},[_c('b',[_vm._v("Conexiones:")]),_vm._v(" "+_vm._s(_vm.timesConecction))]),_c('div',{staticClass:"session-info-subtitle"},[_c('b',[_vm._v("Última:")]),_vm._v(" "+_vm._s(_vm.lastConnection))])])
}
var staticRenderFns = []

export { render, staticRenderFns }